import React, {  } from "react";
import {useForm} from 'react-hook-form';

import mundo from "../../img/mundo.png"
import Pagina from "../comun/Pagina";
import SelectorCP from "../comun/SelectorCP";

const CPSSelectorCP =({
idCP, setIdCP, 
nombreMunRef, nombreCPRef,
irAPagina0, irAConsultaTabla})=>{
    /* configuracion de react-hook-form */
    const {register, handleSubmit, watch, formState: { errors }} = useForm(); 

    const onSubmit= () => {         
        irAConsultaTabla();        
    }   

    return (
    <Pagina
    titulo="Consulta por sitio"
    imgSrc={mundo}
    imgAlt="Consulta por sitio"        
    handleSubmit={handleSubmit}  
    onSubmit={onSubmit}
    botonesNavegacion={ <Botones irAPagina0={irAPagina0}/> }
    explicacion={
        <React.Fragment>
        Permite conocer la intensidad de un sitio para diferentes sismos, evaluada mediante los formularios de "Sismo sentido" reportados en la página web del SGC.
        Se debe seleccionar el departamento, municipio y centro poblado de interés.
        </React.Fragment>
    }
    
    contenidoPrincipal= {
        <><SelectorCP idCP={idCP} setIdCP={setIdCP} nombreMunRef={nombreMunRef} nombreCPRef={nombreCPRef}
            register={register} handleSubmit={handleSubmit} watch={watch} errors={errors} />
        </>
    }
    />
    )
}

export default CPSSelectorCP;

const Botones =(props)=>{
    return (
    <div>
        <button 
        className="BotonAvanzar"
        type="button"
        onClick={ props.irAPagina0 }>
            Inicio
        </button>
        &nbsp;        
        <button 
        className="BotonAvanzar"
        type="submit">
            Consulta
        </button>
    </div>
    )
}